// const Dish15 = "http://winpeforum.com/assets/gelleryimages/JIT_1725.jpg"
// const Dish16 = "http://winpeforum.com/assets/gelleryimages/JIT_1745.jpg"
// const Dish20 = "http://winpeforum.com/assets/gelleryimages/JIT_1787.jpg"
// const Dish24 = "http://winpeforum.com/assets/gelleryimages/JIT_1855.jpg"
// const Dish31 = "http://winpeforum.com/assets/gelleryimages/JIT_1979.jpg"
// const Dish39 = "http://winpeforum.com/assets/gelleryimages/JIT_2131.jpg"
// const Dish40 = "http://winpeforum.com/assets/gelleryimages/JIT_2072.jpg"

const Gell1 = "https://winpeforum.com/assets/gelleryimages/JIT_1760.png"
const Gell2 = "https://winpeforum.com/assets/gelleryimages/JIT_1780.png"
const Gell3 = "https://winpeforum.com/assets/gelleryimages/JIT_1802.png"
const Gell4 = "https://winpeforum.com/assets/gelleryimages/JIT_1811.png"
const Gell5 = "https://winpeforum.com/assets/gelleryimages/JIT_1847.png"
const Gell6 = "https://winpeforum.com/assets/gelleryimages/JIT_1852.png"
const Gell7 = "https://winpeforum.com/assets/gelleryimages/JIT_1866.png"
const Gell8 = "https://winpeforum.com/assets/gelleryimages/JIT_1868.png"
const Gell9 = "https://winpeforum.com/assets/gelleryimages/JIT_1870.png"
const Gell10 = "https://winpeforum.com/assets/gelleryimages/JIT_1879.png"
const Gell11 = "https://winpeforum.com/assets/gelleryimages/JIT_1887.png"
const Gell12 = "https://winpeforum.com/assets/gelleryimages/JIT_1897.png"
const Gell13 = "https://winpeforum.com/assets/gelleryimages/JIT_1899.png"
const Gell14 = "https://winpeforum.com/assets/gelleryimages/JIT_1912.png"
const Gell15 = "https://winpeforum.com/assets/gelleryimages/JIT_1915.png"
const Gell16 = "https://winpeforum.com/assets/gelleryimages/JIT_1928.png"
const Gell17 = "https://winpeforum.com/assets/gelleryimages/JIT_1931.png"
const Gell18 = "https://winpeforum.com/assets/gelleryimages/JIT_1979.png"
const Gell19 = "https://winpeforum.com/assets/gelleryimages/JIT_1981.png"
const Gell20 = "https://winpeforum.com/assets/gelleryimages/JIT_2008.png"
const Gell21 = "https://winpeforum.com/assets/gelleryimages/JIT_2014.png"
const Gell22 = "https://winpeforum.com/assets/gelleryimages/JIT_2026.png"
const Gell23 = "https://winpeforum.com/assets/gelleryimages/JIT_2034.png"
const Gell24 = "https://winpeforum.com/assets/gelleryimages/JIT_2038.png"
const Gell25 = "https://winpeforum.com/assets/gelleryimages/JIT_2039.png"
// const Gell26 = "https://winpeforum.com/assets/gelleryimages/JIT_2072.png"
const Gell27 = "https://winpeforum.com/assets/gelleryimages/JIT_2081.png"
const Gell28 = "https://winpeforum.com/assets/gelleryimages/JIT_2082.png"
const Gell29 = "https://winpeforum.com/assets/gelleryimages/JIT_2116.png"
const Gell30 = "https://winpeforum.com/assets/gelleryimages/JIT_2124.png"
const Gell31 = "https://winpeforum.com/assets/gelleryimages/JIT_1725.jpg"

const gelleryImages = [
	{
		id: 0,
		title: "Winpe Forum Events images",
		imgUrl: Gell31,
	},
	{
		id: 1,
		title: "Winpe Forum Events images",
		imgUrl: Gell1,
	},
	{
		id: 2,
		title: "Winpe Forum Events images",
		imgUrl: Gell2,
	},
	{
		id: 3,
		title: "Winpe Forum Events images",
		imgUrl: Gell3,
	},
	{
		id: 4,
		title: "Winpe Forum Events images",
		imgUrl: Gell4,
	},
	{
		id: 5,
		title: "Winpe Forum Events images",
		imgUrl: Gell5,
	},
	{
		id: 6,
		title: "Winpe Forum Events images",
		imgUrl: Gell6,
	},
	{
		id: 7,
		title: "Winpe Forum Events images",
		imgUrl: Gell7,
	},
	{
		id: 8,
		title: "Winpe Forum Events images",
		imgUrl: Gell8,
	},
	{
		id: 9,
		title: "Winpe Forum Events images",
		imgUrl: Gell9,
	},
	{
		id: 10,
		title: "Winpe Forum Events images",
		imgUrl: Gell10,
	},
	{
		id: 11,
		title: "Winpe Forum Events images",
		imgUrl: Gell11,
	},
	{
		id: 12,
		title: "Winpe Forum Events images",
		imgUrl: Gell12,
	},
	{
		id: 13,
		title: "Winpe Forum Events images",
		imgUrl: Gell13,
	},
	{
		id: 14,
		title: "Winpe Forum Events images",
		imgUrl: Gell14,
	},
	{
		id: 15,
		title: "Winpe Forum Events images",
		imgUrl: Gell15,
	},
	{
		id: 16,
		title: "Winpe Forum Events images",
		imgUrl: Gell16,
	},
	{
		id: 17,
		title: "Winpe Forum Events images",
		imgUrl: Gell17,
	},
	{
		id: 18,
		title: "Winpe Forum Events images",
		imgUrl: Gell18,
	},
	{
		id: 19,
		title: "Winpe Forum Events images",
		imgUrl: Gell19,
	},
	{
		id: 20,
		title: "Winpe Forum Events images",
		imgUrl: Gell20,
	},
	{
		id: 21,
		title: "Winpe Forum Events images",
		imgUrl: Gell21,
	},
	{
		id: 22,
		title: "Winpe Forum Events images",
		imgUrl: Gell22,
	},
	{
		id: 23,
		title: "Winpe Forum Events images",
		imgUrl: Gell23,
	},
	{
		id: 24,
		title: "Winpe Forum Events images",
		imgUrl: Gell24,
	},
	{
		id: 25,
		title: "Winpe Forum Events images",
		imgUrl: Gell25,
	},
	// {
	// 	id: 26,
	// 	title: "Winpe Forum Events images",
	// 	imgUrl: Gell26,
	// },
	{
		id: 27,
		title: "Winpe Forum Events images",
		imgUrl: Gell27,
	},
	{
		id: 28,
		title: "Winpe Forum Events images",
		imgUrl: Gell28,
	},
	{
		id: 29,
		title: "Winpe Forum Events images",
		imgUrl: Gell29,
	},
	{
		id: 30,
		title: "Winpe Forum Events images",
		imgUrl: Gell30,
	},
]

export default { gelleryImages }



// WEBPACK FOOTER //
// ./src/constant/gelleryImages.js